export const PAYMENT_TYPE_HALYK = 'epayment_mixed'

export type PaymentPluginId = typeof PAYMENT_TYPE_HALYK

export const PAYMENT_PLUGIN_NAMES: Record<PaymentPluginId, string> = {
  [PAYMENT_TYPE_HALYK]: 'Банковская карта',
}
